import Typography from "@mui/material/Typography";
import { Grid, Input, InputLabel, Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "index";
import { updateContacts } from "@store/filters/actions";

// Component-specific props.
type ComponentProps = {
  title: string;
};

function ContactFilter(props: ComponentProps) {
  const dispatch = useAppDispatch();

  const range = useAppSelector((state) => state.filters.contactFilterRange);

  return (
    <Box>
      <Typography
        align="center"
        sx={{
          pb: 1,
        }}
      >
        {props.title}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <InputLabel sx={{ marginBottom: "10px", marginLeft: "10px" }}>Min:</InputLabel>
        </Grid>
        <Grid item xs={6} md={9}>
          <Input
            sx={{ marginRight: "40px" }}
            type="number"
            value={range.min}
            onChange={(e) => {
              dispatch(updateContacts({ min: Number(e.target.value), max: range.max }));
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <InputLabel sx={{ marginBottom: "10px", marginLeft: "10px" }}>Max:</InputLabel>
        </Grid>
        <Grid item xs={6} md={9}>
          <Input
            type="number"
            value={range.max}
            sx={{ marginBottom: "10px", marginRight: "40px" }}
            onChange={(e) => {
              dispatch(updateContacts({ min: range.min, max: Number(e.target.value) }));
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ContactFilter;
